import { ArrayParam, StringParam } from "use-query-params"
import { FilterConfig } from "../../hooks/useFilters"
import { searchExpFunc } from "../../utils/lookups"
import ResourcesActions from "../ResourcesActions/ResourcesActions"
import ResourcesFilters from "../ResourcesFilters/ResourcesFilters"
import ResourcesList from "../ResourcesList/ResourcesList"
import ResourceProvider from "../ResourcesProvider/ResourcesProvider"
import styles from './ResourcesView.module.scss'

export default function ResourcesView() {

    const filterConfig: FilterConfig[] = [
        { name: "fileType", variant: ArrayParam, defaultValue: [] },
        { name: "name", variant: StringParam, defaultValue: "", lookupExpFunc: searchExpFunc }
    ]

    return (
        <div className={styles.Wrapper}>
            <ResourceProvider filterConfig={filterConfig}>
                <ResourcesActions />
                <ResourcesFilters />
                <ResourcesList />
            </ResourceProvider>
        </div>
    )

}
